export default function apiCep(cep: string) {
  return `https://viacep.com.br/ws/${cep}/json/`;
}
